export const DIALOG_SIZE = {
  DEFAULT: '600px',
  SMALL: '450px',
};
